import { Empty } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useMemo, useRef } from 'react';
import { SaveKnowledge, SupplementalKnowledgeAiReply } from 'services/api/supplementKnowledge';
import { T, useTranslate } from '@tolgee/react';
import emptySvg from 'views/Knowledge/assets/empty.svg';
import TransComponent from 'components/TransComponent';
import { eventBus } from 'services/eventBus';
import { KnowledgeList } from './KnowledgeList';
import { Container, Title } from './styles';
import { transformKnowledge } from './utils';

function CiteKnowledge({
  caseId,
  conversation,
  aiReply,
  applySkuIds,
  onKnowledgesUpdate,
}: {
  caseId?: number;
  conversation: Conversation.Conversation;
  aiReply: SupplementalKnowledgeAiReply;
  applySkuIds: string[];
  onKnowledgesUpdate?: (knowledegs: SaveKnowledge[][]) => void;
}) {
  const { replyTime, citeKnowledge, sourceKnowledge } = aiReply;

  const { t } = useTranslate();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const knowledgeList = useMemo(() => {
    return transformKnowledge(citeKnowledge, sourceKnowledge);
  }, [citeKnowledge, sourceKnowledge]);

  useEffect(() => {
    const handler = (scrollTop: number = 0) => {
      if (containerRef.current) {
        containerRef.current.scrollTo({
          top: scrollTop,
          behavior: 'smooth',
        });
      }
    };

    eventBus.on('CITE_KNOWLEDGE_SCROLL', handler);

    return () => {
      eventBus.off('CITE_KNOWLEDGE_SCROLL', handler);
    };
  }, []);

  return (
    <Container ref={containerRef}>
      <Title>
        <T
          keyName="从知识库x找到的相关知识"
          params={{
            x: (
              <TransComponent
                content={<span>（{dayjs(replyTime).format('YYYY-MM-DD HH:mm:ss')}）</span>}
              />
            ),
          }}
        />
        （{knowledgeList.length}）
      </Title>
      {knowledgeList.length === 0 ? (
        <Empty
          image={<img src={emptySvg} alt="empty" />}
          description={t('x_not_yet', { x: t('知识') })}
        />
      ) : (
        <>
          <KnowledgeList
            caseId={caseId}
            conversation={conversation}
            knowledgeList={knowledgeList}
            applySkuIds={applySkuIds}
            onKnowledgesUpdate={onKnowledgesUpdate}
          />
        </>
      )}
    </Container>
  );
}

export default CiteKnowledge;
